import { webSocket } from 'rxjs/webSocket'

export default {
  namespaced: true,
  state: () => ({
    websocket$: null,
    sendIntervalId: null
  }),
  actions: {
    connect({ state, commit, dispatch }, payload) {
      if (!state.websocket$) {
        commit('WEBSOCKET$', webSocket(payload))
        return Promise.resolve(state.websocket$)
      }
      return Promise.resolve()
    },
    send({ state }, payload) {
      if (state.websocket$) {
        state.websocket$.next({
          message: payload
        })
      }
      return Promise.resolve()
    },
    disconnect({ state, commit }) {
      if (state.websocket$) {
        state.websocket$.complete()
        commit('WEBSOCKET$', null)
      }
      return Promise.resolve()
    },

    sendInterval({ state, commit, dispatch }, payload) {
      if (state.websocket$) {
        commit(
          'SEND_INTERVAL_ID',
          setInterval(() => {
            if (state.websocket$) {
              dispatch('send', payload)
            } else {
              dispatch('clearSendInterval')
            }
          }, 5 * 1000)
        )
      }
    },
    clearSendInterval({ state, commit }) {
      if (state.sendIntervalId) {
        clearInterval(state.sendIntervalId)
        commit('SEND_INTERVAL_ID', null)
      }
    }
  },
  mutations: {
    WEBSOCKET$(state, payload) {
      state.websocket$ = payload
    },
    SEND_INTERVAL_ID(state, payload) {
      state.sendIntervalId = payload
    }
  },
  getters: {
    websocket$(state) {
      return state.websocket$
    },
    sendIntervalId(state) {
      return state.sendIntervalId
    }
  }
}
